// extracted by mini-css-extract-plugin
export default {"top":"prodSidebar_top__hJOfm","bottom":"prodSidebar_bottom__DlPEY"};